import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=10a48d98&scoped=true"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"
import style0 from "./styles/save.scss?vue&type=style&index=0&id=10a48d98&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a48d98",
  null
  
)

export default component.exports